import { render, staticRenderFns } from "./number_rule.vue?vue&type=template&id=953a083c&scoped=true"
import script from "./number_rule.vue?vue&type=script&lang=js"
export * from "./number_rule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953a083c",
  null
  
)

export default component.exports